import { render, staticRenderFns } from "./ConservationPurposesCard.vue?vue&type=template&id=01e8c518"
import script from "./ConservationPurposesCard.vue?vue&type=script&lang=js"
export * from "./ConservationPurposesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports